export default __webpack_public_path__ + "static/media/attendiz.9002d2b0.png";